import React, { useEffect, useState, useRef  } from "react";
import "../backtester.css";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";

const Backtester = () => {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const detailsRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
    const BASE_URL = process.env.REACT_APP_BASE_URL;


  useEffect(() => {
    fetch(`${BASE_URL}/fetchActiveQueAns`)
      .then((res) => res.json())
      .then((response) => {
        if (response?.data) {
          const homepageFaqs = response.data.filter(
            (item) => item.section === "backtester"
          );
  
          setFaqs(homepageFaqs);
        }
      })
      .catch((err) => console.error("FAQ Fetch Error:", err));
  }, []);

    const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleSubscribe = (store) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      if (store === "android") {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.bossinvestor.app";
      } else if (store === "ios") {
        window.location.href =
          "https://apps.apple.com/us/app/example-app/id123456789"; // replace with real ID
      }
    } else {
      setShowPopup(true);
    }
  };


  return (
    <>
      <UnauthorizedNavbar />

      <div className="mp-wrapper" style={{background: 'linear-gradient(to bottom right, #f1e8f7, #fdf4e7'}}>
        <header className="header-section">
          <h1 className="backtester-header-title">
            Validate Your Strategy With <br className="hide-md" />
            <span className="text-brand-gradient">Ultimate Backtesting Tool.</span>
          </h1>
          <p className="backtester-header-subtitle">
            Simulate 10+ years of market data instantly. Verify swing trading strategies with our no-code backtesting engine risk-free.
          </p>
        </header>

        <div className="cta-wrapper">
          <a onClick={() => handleSubscribe("android")} className="backtester-btn-primary">
            <i className="fas fa-download"></i>
            Download App
          </a>
          <a
            href="#"
            className="backtester-btn-secondary"
            onClick={(e) => {
              e.preventDefault();
              detailsRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });
            }}
          >
            Learn More
          </a>
        </div>

        <section ref={detailsRef} className="backtester-page-section">
            <h2 className="bt-title">Understanding the BossInvestor Backtester</h2>
            <p className="bt-desc-subtitle">
              Most retail investors rely on "gut feeling" or tips. 
              Institutional investors rely on data. 
              The BossInvestor Backtester bridges this gap by offering India’s most intuitive <b>No-Code Backtesting Tool. </b> 
              We give you access to <b>10 years of historical market data</b>, 
              allowing you to validate your investment ideas before risking a single rupee.
              It transforms you from a guesser into a data-driven <b>Research Analyst</b>.
            </p>

            <h3 className="bt-subtitle">How It Works</h3>

            <p className="bt-desc">
              Our engine democratizes quantitative analysis. You don't need to know Python or coding. 
              You simply select from our pre-defined parameters via dropdown menus, and our system runs a professional-grade simulation:
            </p>

            <p className="bt-desc">
              <b>• Select Your Factor: </b>Choose the core driver of your strategy. Price Momentum is the default, but you can also test Stock Valuation, Growth Potential, Market Leadership, or Profitability.<br/>
              <b>• Set the Rules: </b>Use simple dropdowns to define Entry Conditions (when to buy), Holding Period (how long to stay), and Exit Conditions (when to book profit).<br/>
              <b>• Run the Simulation: </b>Input your initial investment amount (e.g., ₹10 Lakh) to see exactly how much money you would have made over the last 10 years by following this process.<br/>
              <b>• Get Live Signals: </b>If you run the strategy for the Current Month, the system generates a list of live stock selections, empowering you to execute high-conviction DIY trades immediately.
            </p>

            <h3 className="bt-subtitle">Key Metrics You Will See</h3>

            <div className="bt-metric-grid">
              <div className="bt-card border-purple">
                <h4>Capital Growth</h4>
                <p>See exactly how much your initial capital would have grown over the 10-year test period.</p>
              </div>

              <div className="bt-card border-orange">
                <h4>CAGR</h4>
                <p>The smoothed annual return of your strategy, allowing you to benchmark against Nifty.</p>
              </div>

              <div className="bt-card border-blue">
                <h4>Cumulative Returns</h4>
                <p>The total aggregate percentage gain of your portfolio, demonstrating the power of compounding over the full decade.</p>
              </div>

              <div className="bt-card border-green">
                <h4>Maximum Drawdown</h4>
                <p>The largest percentage drop from a peak to a trough, measuring the maximum risk or volatility you would have endured.</p>
              </div>
            </div>


            <h3 className="bt-subtitle">Look & Feel of the BossInvestor’s Backtester</h3>
            <div className="bt-screenshot-grid">
              <div className="bt-screenshot-card">
                <img src="/backtester/SS1.jpg" alt="Build Strategy Step 1" />
                <p>Build Strategy – Select Factors</p>
              </div>

              <div className="bt-screenshot-card">
                <img src="/backtester/SS2.jpg" alt="Build Strategy Step 2" />
                <p>Configure Entry, Hold & Exit Rules</p>
              </div>

              <div className="bt-screenshot-card">
                <img src="/backtester/SS3.jpg" alt="Build Strategy Step 3" />
                <p>Set Capital, Dates & Rebalance</p>
              </div>

              <div className="bt-screenshot-card">
                <img src="/backtester/SS4.jpg" alt="Backtest Results" />
                <p>Backtest Results & Performance Metrics</p>
              </div>

              <div className="bt-screenshot-card">
                <img src="/backtester/SS5.jpg" alt="Live Trades" />
                <p>Live Trades Generated by Strategy</p>
              </div>

              <div className="bt-screenshot-card">
                <img src="/backtester/SS6.jpg" alt="Past Trades" />
                <p>Past Trades & Historical Performance</p>
              </div>

            </div>

            <p className="bt-note">
              Note: Backtesting results are based on 10 years of historical data to help understand framework reliability. Past performance does not guarantee future returns.
            </p>
        </section>

        <section style={{paddingTop : '130px', paddingBottom:'50px', marginBottom:'0px !important'}}>
          <div className="backtester-faq-container">
            <h2 className="faq-title">Frequently Asked Questions</h2>
              <div className="faq-list">
                {faqs.map((faq, index) => (
                  <div key={faq.id} className="faq-item">
                    <button
                      className="faq-question"
                      onClick={() => toggleFaq(index)}
                    >
                      <span>{faq.question}</span>
                      <svg
                        className={`faq-icon ${openIndex === index ? "open" : ""}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        ></path>
                      </svg>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                ))}
              </div>
          </div>
        </section>
      </div>

       {showPopup && (
        <div className="qr-overlay" onClick={() => setShowPopup(false)}>
          
          <div className="qr-modal" onClick={(e) => e.stopPropagation()}>

            <button className="qr-close-icon" onClick={() => setShowPopup(false)}>
              ✕
            </button>

            <h2 className="qr-title">Get the Bossinvestor App</h2>
            <img 
              src="/playstoreScanner.jpeg" 
              alt="QR Code" 
              style={{ width: "170px", height: "170px", borderRadius: "12px" }}
            />
            <p className="qr-subtitle">
              Scan the QR code to download the app
            </p>

          </div>
        </div>
      )}
      <UnauthorizedFooter />
    </>
  );
};

export default Backtester;
